<template>
  <div class="special-main ">
    <div class="special-body">
      <div class="banner-container" ref="bannerContainerRef">
        <div class="banner" ref="bannerRef">
          <div class="banner-logo">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260111/b2854b2be4cd927e35478aa0f52897b8.jpg" alt="">
          </div>
          <p class="banner-title">
            让预备更智能
          </p>
          <div class="banner-product">
            <img @load="onImageLoad" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/a75ef6a5e9017736414456a651e30bfa.png" alt="">
          </div>
          <!--          <img  @load="onImageLoad" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251213/c6a240bdcae136014d3cc484e3d404b0.jpg" alt="">-->
        </div>
        <div class="preview-video-container" ref="previewVideoContainerRef">
          <div class="preview-video-box" ref="previewVideoBoxRef">
          </div>
          <div class="preview-video-text" ref="previewVideoTextRef">
            <h4>扭矩更稳</h4>
            <h4>测量更准</h4>
            <h4>锉序列自定义</h4>
            <h4>操作更自由</h4>
            <endo-button @onclick="openVideoModal(videoList[0].previewVideo)"></endo-button>
          </div>
          <div class="progress">
            <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>
          </div>
          <video class="background-video"
                 :ref="videoList[0].ref"
                 :src="videoList[0].video"
                 muted
                 playsinline
                 loop
          ></video>
        </div>
      </div>

      <div class="section-product-desc">
        <div class="product-logo">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/87e903851c3d897212cbc769f7cbf820.png" alt="">
        </div>
        <div class="product-logo-text">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/67e1d823677d4b4c5aff4dcee4305af0.png" alt="">
        </div>
        <div class="product-image">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/53bcd6f9b799a2382480c45080755cbe.png" alt="">
        </div>
        <div class="product-special-title">
          <div class="product-special-title-b">
            <h5>智能扭矩 预备更自如</h5>
            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>
          </div>
        </div>
        <div class="product-detail-text1"  style="text-align: center;">
          <p class="txt">在连续锉模式下</p>
          <p class="txt">可实时分析牙本质阻力</p>
          <p class="txt">自动匹配根管不同区域所需扭矩</p>
          <p class="txt">在确保高效切削的同时</p>
          <p class="txt">有效降低扭转疲劳与锉断风险</p>
          <endo-button @onclick="openVideoModal(videoList[1].previewVideo)"></endo-button>
        </div>

        <div class="product-video-container">
          <div class="progress">
            <circular-progress :progress="videoList[1].progress" :isPlaying="videoList[1].playing" index="1" @togglePlay="togglePlay"/>
          </div>
          <video class="product-video"
                 :ref="videoList[1].ref"
                 :src="videoList[1].video"
                 muted
                 playsinline
                 loop
          ></video>
        </div>

        <div class="product-detail-text1 product-detail-text2">
          <p class="txt">马达持续监测扭矩并自动设定安全阈值</p>
          <p class="txt">扭矩超限时自动切换往复模式</p>
          <p class="txt">不同锉型无需单独设定扭矩</p>
        </div>

        <div class="step-list">
          <div class="step-item">
            <video class="step-video-1"
                   :ref="videoList[2].ref"
                   :src="videoList[2].video"
                   muted
                   playsinline
                   loop
            ></video>
            <div class="step-video-txt">
              <div class="step-video-title">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">
                <h5>步骤 1</h5>
              </div>
              <p class="txt-big mt-15">2<span class="txt-middle">s</span></p>
              <p class="txt-small">检测扭矩</p>
            </div>
          </div>
          <div class="step-item">
            <video class="step-video-2"
                   :ref="videoList[3].ref"
                   :src="videoList[3].video"
                   muted
                   playsinline
                   loop
            ></video>
            <div class="step-video-txt">
              <div class="step-video-title">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">
                <h5>步骤 2</h5>
              </div>
              <p class="txt-small mt-25">自动设置</p>
              <p class="txt-small">理想扭矩</p>
            </div>
          </div>
          <div class="step-item">
            <video class="step-video-3"
                   :ref="videoList[4].ref"
                   :src="videoList[4].video"
                   muted
                   playsinline
                   loop
            ></video>
            <div class="step-video-txt">
              <div class="step-video-title">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">
                <h5>步骤 3</h5>
              </div>
              <p class="txt-small mt-25">超过则往复</p>
            </div>
          </div>
        </div>
      </div>

      <div class="section-product-suit section-product-desc">
        <div class="product-logo">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/fd75dc0a2eb9cc522f4458e6482640d0.png" alt="">
        </div>
        <div class="product-logo-text">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/ef9dacf873710fd3a4777acd9297cc29.png" alt="">
        </div>
        <div class="product-special-title">
          <div class="product-special-title-b">
            <h5>稳定测量 更准更清晰</h5>
            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>
          </div>
        </div>

        <div class="product-detail-text1"  style="text-align: center;">
          <p class="txt">电子测量若不稳定容易造成根尖定位误差</p>
          <p class="txt">ClearSignal™ 技术可实时评估信号稳定性</p>
          <p class="txt">帮助判断连接是否可靠</p>
          <p class="txt">提升根尖测量的准确性</p>
          <endo-button @onclick="openVideoModal(videoList[5].previewVideo)"></endo-button>
        </div>

        <div class="g-preview-video-container product-video-container">
          <div class="progress">
            <circular-progress :progress="videoList[5].progress" :isPlaying="videoList[5].playing" index="5" @togglePlay="togglePlay"/>
          </div>
          <video class="g-preview-video product-video"
                 :ref="videoList[5].ref"
                 :src="videoList[5].video"
                 muted
                 playsinline
                 loop
          ></video>
        </div>

        <div class="product-detail-text1 product-detail-text2 product-detail-text3">
          <p class="txt">系统可同步显示电子信号稳定性</p>
          <p class="txt">轻触仪表盘即可获得屏幕提示与引导</p>
        </div>

        <div class="g-mode-video-container product-video-container">
          <video class="g-mode-video product-video"
                 :ref="videoList[6].ref"
                 :src="videoList[6].video"
                 muted
                 playsinline
                 loop
                 @canplaythrough="onModeVideoLoaded"
          ></video>
        </div>
      </div>

      <div class="improved-container" ref="improvedContainerRef">
        <div class="improved-banner" >
          <img @load="onImprovedBanner" :style="{top: -improvedBannerTop + 'px'}" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260118/aee5559d4caf2d8c114ba48a292657b5.jpg" alt="">
          <!--          <div style="background-image: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260118/aee5559d4caf2d8c114ba48a292657b5.jpg');width: 100%;height: 100%;"></div>-->
          <div class="blur-after"></div>
          <div class="improved-background"></div>
          <div class="improved-banner-text">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <h5>先进弯手机</h5>
                <h5>控制技术</h5>
              </div>
              <div class="product-special-title-p">
                <p>可精准适配多类型锉型的往复角度</p>
                <p>并快速切换 TorqueSense、</p>
                <p>ATR 等运动模式</p>
                <p>操作响应更迅速，也更贴合临床需求</p>
              </div>
            </div>
          </div>
        </div>

        <div class="improved-content" ref="improvedContentRef">
          <div class="improved-content-container">
            <div class="improved-content-title-info">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <h5>多重保护</h5>
                  <h5>让根管预备更可控</h5>
                  <h5>更安心</h5>
                </div>
              </div>
            </div>
            <div class="improved-content-detail">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <h5>根尖动态预警：操作心中有数</h5>
                </div>
                <div class="product-special-title-p">
                  <p>声光渐进提示：锉针接近根尖时，提示音由弱渐强，到达根尖LED指示灯同步闪烁提示，动态提示预备深度。</p>
                  <p>动态轨迹监测：屏幕实时显示锉针在根管内的位置趋势，让操作一目了然。</p>
                </div>
              </div>
            </div>
            <div class="improved-content-detail">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <h5>智能预设控制：多种自动辅助</h5>
                </div>
                <div class="product-special-title-p">
                  <p>进出根管自动启停: 锉针进入根管自动运转，离开即停，简化手动操作。</p>
                  <p>接近根尖自动减速：临近根尖报警点自动降低转速，便于医生从容操作。</p>
                  <p>到达根尖智能响应：到达根尖报警点时可设置自动反转或自动停止，辅助医生避免过度预备。</p>
                </div>
              </div>
            </div>

            <div class="improved-button">
              <endo-button @onclick="openVideoModal(videoList[9].previewVideo)"></endo-button>
            </div>
          </div>

          <!--          <div class="torque-sense">-->
          <!--            <div class="torque-sense-logo">-->
          <!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/8da99d7895634c11c0388d0b4b68907a.png" alt="">-->
          <!--            </div>-->
          <!--            <div class="product-special-title">-->
          <!--              <div class="product-special-title-b">-->
          <!--                <h5>TorqueSense</h5>-->
          <!--              </div>-->
          <!--              <div class="product-special-title-p">-->
          <!--                <p>Effortless torque</p>-->
          <!--                <p>control with precise</p>-->
          <!--                <p>adjustments</p>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="atr-mode">-->
          <!--            <div class="atr-mode-logo">-->
          <!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/173dba0a4e426292c168e6b19dcad79b.png" alt="">-->
          <!--            </div>-->
          <!--            <div class="product-special-title">-->
          <!--              <div class="product-special-title-b">-->
          <!--                <h5>ATR Mode</h5>-->
          <!--              </div>-->
          <!--              <div class="product-special-title-p">-->
          <!--                <p>Reciprocation is ignited</p>-->
          <!--                <p>when the torque is</p>-->
          <!--                <p>surpassedas a safety feature</p>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>

      <div class="contra-angle-container">
        <div class="contra-angle-banner">
          <div class="contra-angle-box">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260126/b6fae8e10d30f115833d98ad4ed608d9.png" alt=""/>
            <div class="product-special-title">
              <div class="bending-head">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260521/8b5ea166df15f2c848f661f9d0808993.jpg" alt="">
              </div>
              <div class="product-special-title-b">
                <h5>8mm</h5>
                <h5>超薄弯机头</h5>
              </div>
              <div class="product-special-title-p">
                <p>轻松进入后牙区</p>
              </div>
            </div>
          </div>
          <div class="contra-angle-banner-text">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <h5>LED手柄</h5>
                <h5>可调冷光设计</h5>
              </div>
              <div class="flex contra-angle-parameter">
                <div class="bottom-align">
                  <div class="product-special-title-b">
                    <h5 style="vertical-align: bottom;">≥8000</h5>
                  </div>
                  <div class="product-special-title-p">
                    <p>lux</p>
                  </div>
                </div>
                <!--                <div class="bottom-align">-->
                <!--                  <div class="product-special-title-b">-->
                <!--                    <h5>8 mm</h5>-->
                <!--                  </div>-->
                <!--                  <div class="product-special-title-p">-->
                <!--                    <p>diameter</p>-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
              <div class="product-special-title-p contra-angle-desc">
                <p>确保视野明亮无阴影</p>
              </div>
            </div>
          </div>
        </div>
        <div class="contra-angle-animation">
          <div class="contra-angle-slider">
            <i class="dark">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/791eea63527aa78c4a20687435031129.png" alt="">
            </i>
            <el-slider v-model="contraAngleSliderValue" :show-tooltip="false" :max="contraAngleBanner.length" @input="listenMove"></el-slider>
            <i class="light">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/234999d86aa2515b99003560dc84cb3e.png" alt="">
            </i>
          </div>
          <div class="contra-angle-animation-container">
            <img ref="contraAngleAnimationRef" :src="contraAngleBanner[0]" alt="">
          </div>
        </div>
      </div>

      <div class="section-build-file">
        <div class="product-special-title">
          <div class="product-special-title-b">
            <h5>锉系统 自由掌控</h5>
            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>
          </div>
        </div>
        <div class="product-detail-text1"  style="text-align: center;">
          <p class="txt">内置常用锉序列，开机即可使用，系统支持Wi-Fi软件在线升级</p>
          <p class="txt">锉库可随软件同步更新，始终紧跟最新标准。直观界面支持自定义锉与锉序列</p>
          <p class="txt">可按锉号、锥度、长度等参数创建专属锉型。也可将多品牌锉与自建锉组合为混合序列</p>
          <p class="txt">无论预备通路、MB2 或宽大复杂根管皆可构建独立、针对性的操作方案</p>
        </div>

        <div class="build-file-video-container product-video-container">
          <video class="build-file-video product-video"
                 :ref="videoList[7].ref"
                 :src="videoList[7].video"
                 muted
                 playsinline
                 loop
          ></video>
        </div>
      </div>

      <div class="selection-magnetic">
        <div class="product-special-title">
          <div class="product-special-title-b">
            <h5>手柄与主机无线连接</h5>
          </div>
        </div>
        <div class="product-detail-text1"  style="text-align: center;">
          <p class="txt">磁吸底座轻松对接</p>
          <p class="txt">实现便捷的无接触充电</p>
        </div>
        <div class="section-product-desc">
          <div class="magnetic-video-container product-video-container">

            <div class="progress">
              <circular-progress :progress="videoList[8].progress" :isPlaying="videoList[8].playing" index="8" @togglePlay="togglePlay"/>
            </div>
            <video class="magnetic-video product-video"
                   :ref="videoList[8].ref"
                   :src="videoList[8].video"
                   muted
                   playsinline
                   loop
            ></video>
          </div>
        </div>
      </div>

      <div class="section-touch-screen">
        <div class="touch-screen-list">
          <div class="touch-screen-item">
            <div class="product-special-title">
              <div class="product-special-title-b">
                <h5>6 英寸</h5>
                <h5>高清触控屏</h5>
              </div>
            </div>
            <div class="image">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/f055b846712d32b00ca5269fa5fa8cef.png" alt=""/>
            </div>
          </div>
          <div class="touch-screen-item">
            <div class="product-special-title">
              <div class="product-detail-text1">
                <p class="txt">在强光下依然清晰可见</p>
                <p class="txt">可戴手套流畅操作</p>
                <p class="txt">快捷预设提升临床效率</p>
              </div>
            </div>
            <div class="image">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/bc98871ecd2c3c870d358a7ff2f71fd5.png" alt=""/>
            </div>
          </div>

        </div>

        <div class="section-packaging">
          <div class="product-special-title">
            <div class="product-special-title-b">
              <h5>可降解包装 减轻地球负担</h5>
            </div>
          </div>
          <div class="product-detail-text1"  style="text-align: center;">
            <p class="txt">我们持续减少塑料的使用。产品包装选用符合严苛环保标准的可生物降解材料，在满足产品保护与使用体验的同时，</p>
            <p class="txt">尽量降低对环境的长期影响。</p>
            <p class="txt">给地球的礼物，从一份会“消失”的包装开始。</p>
          </div>

          <div class="image">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260718/a91093ecc410c6cd6962a52c46537609.jpg" alt=""></img>
          </div>
        </div>

        <div class="keep-exploring">
          <div class="product-special-title">
            <div class="product-special-title-b">
              <h5>配置</h5>
            </div>
          </div>
          <div class="keep-exploring-container">
            <div class="keep-exploring-product">
              <div class="image">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/5df5bda98ad17adcec553915da520fa2.png" alt=""/>
              </div>
              <div class="desc">
                <div class="title">Endo GT Pro</div>
                <div class="info">手柄内置根测</div>
                <div class="info">主机内置根测</div>
                <div class="info">无线脚踏</div>
              </div>
            </div>
            <div class="keep-exploring-product-parameter">
              <div class="keep-exploring-product-parameter-item">
                <div class="param">6:1弯机头 * 2</div>
                <div class="param">手柄 * 1</div>
                <div class="param">主机 * 1</div>
                <div class="param">无线脚踏 * 1</div>
                <div class="param">电源适配器 * 2</div>
                <div class="param">锉夹 * 4</div>
              </div>
              <div class="keep-exploring-product-parameter-item">
                <div class="param">唇钩 * 5</div>
                <div class="param">探针 * 2</div>
                <div class="param">充电底座 * 1</div>
                <div class="param">测量线 * 1</div>
                <div class="param">测试器 * 1</div>
              </div>
              <div class="keep-exploring-product-parameter-item">
                <div class="param">注油嘴 * 1</div>
                <div class="param">一次性保护套 * 10</div>
                <div class="param">硅胶保护套 * 2</div>
                <div class="param">说明书 * 1</div>
                <div class="param">装箱单* 1</div>
              </div>
            </div>
<!--            <i class="line"></i>-->
<!--            <div class="mode-list">-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/5df5bda98ad17adcec553915da520fa2.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT mini</h5>-->
<!--                </div>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT</h5>-->
<!--                </div>-->
<!--                <p class="txt pl-145 fc">手柄内置根测</p>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--                <p class="txt txt-center fc">-</p>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT Pro</h5>-->
<!--                </div>-->
<!--                <p class="txt pl-132 fc">手柄内置根测</p>-->
<!--                <p class="txt pl-132 fc">主机内置根测</p>-->
<!--                <p class="txt pl-132 fc">无线脚踏</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <i class="line"></i>-->

<!--            <div class="mode-function mode-list">-->
<!--              <div class="mode-function-item mode-item">-->
<!--                <p class="title pl-120">Endo GT Mini</p>-->
<!--                <p class="txt pl-120">6:1弯机头 * 2</p>-->
<!--                <p class="txt small pl-120">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4 pl-120">手柄 * 1</p>-->
<!--                <p class="txt pl-120">主机 * 1</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">电源适配器 * 1</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">充电底座 * 1</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">注油嘴 * 1</p>-->
<!--                <p class="txt pl-120">一次性保护套 * 10</p>-->
<!--                <p class="txt pl-120">-</p>-->
<!--                <p class="txt pl-120">说明书 * 1</p>-->
<!--                <p class="txt pl-120">装箱单 * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item">-->
<!--                <p class="title pl-145">Endo GT</p>-->
<!--                <p class="txt pl-145">6:1弯机头 * 2</p>-->
<!--                <p class="txt small pl-145">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4 pl-145">手柄 * 1</p>-->
<!--                <p class="txt pl-145">主机 * 1</p>-->
<!--                <p class="txt pl-145">-</p>-->
<!--                <p class="txt pl-145">电源适配器 * 1</p>-->
<!--                <p class="txt pl-145">锉夹 * 4</p>-->
<!--                <p class="txt pl-145">唇钩 * 5</p>-->
<!--                <p class="txt pl-145">探针 * 2</p>-->
<!--                <p class="txt pl-145">充电底座 * 1</p>-->
<!--                <p class="txt pl-145">测量线 * 1</p>-->
<!--                <p class="txt pl-145">测试器 * 1</p>-->
<!--                <p class="txt pl-145">注油嘴 * 1</p>-->
<!--                <p class="txt pl-145">一次性保护套 * 10</p>-->
<!--                <p class="txt pl-145">硅胶保护套 * 2</p>-->
<!--                <p class="txt pl-145">说明书 * 1</p>-->
<!--                <p class="txt pl-145">装箱单 * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item">-->
<!--                <p class="title pl-132">Endo GT Pro</p>-->
<!--                <p class="txt pl-132">6:1弯机头 * 2</p>-->
<!--                <p class="txt small pl-132">(一个带LED的/另一个较小且无LED)</p>-->
<!--                <p class="txt mt-4 pl-132">手柄 * 1</p>-->
<!--                <p class="txt pl-132">主机 * 1</p>-->
<!--                <p class="txt pl-132">无线脚踏 * 1</p>-->
<!--                <p class="txt pl-132">电源适配器 * 2</p>-->
<!--                <p class="txt pl-132">锉夹 * 4</p>-->
<!--                <p class="txt pl-132">唇钩 * 5</p>-->
<!--                <p class="txt pl-132">探针 * 2</p>-->
<!--                <p class="txt pl-132">充电底座 * 1</p>-->
<!--                <p class="txt pl-132">测量线 * 1</p>-->
<!--                <p class="txt pl-132">测试器 * 1</p>-->
<!--                <p class="txt pl-132">注油嘴 * 1</p>-->
<!--                <p class="txt pl-132">一次性保护套 * 10</p>-->
<!--                <p class="txt pl-132">硅胶保护套 * 2</p>-->
<!--                <p class="txt pl-132">说明书 * 1</p>-->
<!--                <p class="txt pl-132">装箱单 * 1</p>-->
<!--              </div>-->
<!--            </div>-->
            <i class="line" style="margin-top: 53px;"></i>

            <div class="specifications-container">
              <div class="product-special-title">
                <div class="product-special-title-b">
                  <h5>参数</h5>
                </div>
              </div>

              <div class="specifications-list ">
                <div class="specifications-item">
                  <p class="txt">转速</p>
                  <p class="title">Endo GT Pro:50-3100 r/min</p>
                  <p class="title ml-120">Endo GT/Endo GT mini:50-3000 r/min</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">扭矩</p>
                  <p class="title">0.4-5.0 N·cm</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">转速比</p>
                  <p class="title">6:1</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">集成LED</p>
                  <p class="title">≥8000 lux</p>
                </div>
                <div class="specifications-item">
                  <p class="txt">模式</p>
                  <p class="title">EAL, CW, CCW, REC (SGP), TorqueSense</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <video-modal ref="videoModalRef"></video-modal>
    </div>
  </div>
</template>

<script>


import circularProgress from "../components/progress-circle.vue";
import endoButton from './components/button.vue'
import videoModal from '../components/video-modal.vue'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
//
export default {
  components: {
    circularProgress,
    endoButton,
    videoModal
  },
  data() {
    return {
      is_mounted: false,
      productc_nav: false,
      videoProgress: 0,
      videoIsPlaying: true,
      contraAngleSliderValue: 0,
      videoList: [
        {
          ref: 'previewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5a9988195001834812351619254/JHyfMZyvJ4AA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/31945f305145403727499858325/onY3N6YlBGoA.mp4',
        },
        {
          ref: 'productVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/473fa3e65145403709194452288/1J1BHLRNKowA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/0a904e8d5145403727508829099/zoacC7caMfYA.mp4'
        },
        {
          ref: 'stepVideo1Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fcf2e8ce5145403709301500262/VQfT2rFuHmMA.mp4'
        },
        {
          ref: 'stepVideo2Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/f8eb701c5145403709301390188/araDpiDEcgAA.mp4'
        },
        {
          ref: 'stepVideo3Ref',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/cbbea11d5145403713214694823/WqHRUq4qiicA.mp4'
        },
        {
          ref: 'gPreviewVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/7e22f7285145403709306548865/CUggH2zVoPcA.mp4',
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/afecc5db5145403727507270713/FUPyuOOaVVUA.mp4'
        },
        {
          ref: 'gModeVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/a960dc375145403713224008980/hruOoezPeoUA.mp4'
        },
        {
          ref: 'buildFileVideoRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fee05aaa5145403715045789494/DIyA9cfuckQA.mp4'
        },
        {
          ref: 'magneticRef',
          progress: 0,
          playing: false,
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/36843a685145403714294898054/bbSFtNG3RrwA.mp4'
        },
        {
          ref: 'improvedRef',
          progress: 0,
          playing: false,
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/668ec2795001834812208794150/aRfIS54DqV8A.mp4'
        }
      ],
      contraAngleBanner: [
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c6067e872b55e5d6acf177939ac5a0c8.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/b59ba70340db05e588244f83f18a0f8e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/493cc727e1a9b5e616f29a2211ac7104.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/9ead80eb13be4a13f0f3cdc42285c9ff.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/72ce736cd62207015f96a91f83752ce6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/649aa3dd9b0219be20c02dbb3ea41cb4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/040fbcef9345317e6d5f8b63634507eb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/8238944342b81f5b8134ce2b715286e7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6d2c31c66743625370ef787fb2ec1b27.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/de71d210ca45ff166b222da3732253a6.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ab90e7a6d3975e0a29c92cf0b6a31417.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/0c819732e2b2468b7fca309e559f25d0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/16a6ce0e7b967e2f87251c7bad80659e.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d280151d0cb8197d4aa42a787c454db4.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ec6e696ef61b2e74fd5180921dd96b63.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/e6d25395da38d05f2d50bb58f900e4ec.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/a1956fe4da20f7f1e849500bc86a33c7.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/da1db807c80ef7d3cda11b17dba77314.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/afc00c7d7b782b7d0d89a67fd164c570.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/7fb5b76f81a3d809d1228a704bc74b20.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/debef22e218b390390be149c6ff5d2a0.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/cb6940cd8b4f2b756961b647d2ac8e88.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c68e77cb7327bb6b434b16d420a86eca.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6e13e064ac62342482f6871cf419acfb.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/413f3dbb1a3eea85c927879f1b952ef9.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d73bc851d358422a7fa81b61e8c3e8db.jpg',
        'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/5d117257f053179f6f41ae8d2f60dab5.jpg',
      ],
      positionNav: [
        {
          title: 'Endo GT Series',
          path: '/pc/special/endo'
        },
      ],
      moveStart: true,
      improvedBannerTop: 0,
      isImprovedContainerRef: false
    };
  },
  mounted() {
    let that = this
    this.$nextTick(() => {
      this.is_mounted = true

      this.addSliderHoverListener();
      document.addEventListener('scroll', this.handleScroll, false)

      this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('scroll', this.handleScroll, false)
      })
    })
  },
  created() {

  },
  methods: {
    addSliderHoverListener() {
      this.$nextTick(() => {
        const sliderButtonWrapper = document.querySelector('.el-slider__button-wrapper');

        if (sliderButtonWrapper) {
          sliderButtonWrapper.addEventListener('mouseenter', this.onSliderMouseEnter);
          sliderButtonWrapper.addEventListener('mouseleave', this.onSliderMouseLeave);
          this.contraAngleBannerMove()
        }
      });
    },
    onSliderMouseEnter() {
      this.moveStart = false
    },

    onSliderMouseLeave() {
      this.moveStart = true
    },
    removeSliderHoverListener() {
      const sliderButtonWrapper = document.querySelector('.el-slider__button-wrapper');

      if (sliderButtonWrapper) {
        sliderButtonWrapper.removeEventListener('mouseenter', this.onSliderMouseEnter);
        sliderButtonWrapper.removeEventListener('mouseleave', this.onSliderMouseLeave);
      }
    },
    openVideoModal(url){
      this.$refs.videoModalRef.open(url)
    },
    listenMove(value){
      if(value < this.contraAngleBanner.length){
        this.$refs.contraAngleAnimationRef.src = this.contraAngleBanner[value]
      }
    },
    contraAngleBannerMove(){
      if(this.moveStart){
        if(this.contraAngleSliderValue >= (this.contraAngleBanner.length - 1)){
          this.contraAngleSliderValue = 0
        }
        this.contraAngleSliderValue++
      }
      setTimeout(() => {
        this.contraAngleBannerMove()
      }, 500)
    },
    togglePlay(index) {
      this.videoList[index].playing = !this.videoList[index].playing;
      if(this.videoList[index].playing){
        this.$refs[this.videoList[index].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
      }else {
        this.$refs[this.videoList[index].ref].pause();
      }
    },
    onImageLoad(){
      this.initScrollAnimation();
    },
    onModeVideoLoaded(){
      // this.initImprovedBannerAnimation()
    },
    onImprovedBanner(){
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //     this.initImprovedBannerAnimation()
      //   }, 500)
      // })
      this.initImprovedBannerPosition()
    },
    initImprovedBannerPosition(){
      const imgElement = document.querySelector('.special-main .special-body .improved-container .improved-banner img');
      if (imgElement) {
        const height = imgElement.offsetHeight;
        let space = window.innerHeight - height
        let top = 0
        if(space < 0){
          top = Math.abs(space) - 1
          // if(top > 310){
          //   top = 310
          // }
        }
        this.improvedBannerTop = top
      }
    },
    initImprovedBannerAnimation(){
      gsap.timeline({
        scrollTrigger: {
          trigger: ".improved-container",
          start: `top top`,
          end: `+=1000`,
          scrub: true,
          pin: true,
          onEnter: () => {
          },
        }
      }).to('.improved-banner-text', {
        opacity: 0
      })
          .to('.improved-background', {
            opacity: 1,
          }, '<')
          .to('.improved-content',{
            y: `-100vh`
          }, '<')
    },
    initScrollAnimation(){
      const _this = this

      const bannerElement = document.querySelector('.banner')

      this.videoList.forEach(item => {
        if(this.$refs[item.ref]){
          this.$refs[item.ref].addEventListener('timeupdate', this.onVideoProgress);
        }
      })
      this.setupVideoIntersectionObserver()

      gsap.timeline({
        scrollTrigger: {
          trigger: ".banner-container",
          start: `top top`,
          end: `+=2000`,
          scrub: true,
          pin: true,
          onEnter: () => {
            if (this.$refs[this.videoList[0].ref]) {
              this.$refs[this.videoList[0].ref].currentTime = 0;
              this.videoList[0].playing = true
              this.$refs[this.videoList[0].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
            }
          },
        }
      }).to(this.$refs.previewVideoContainerRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoTextRef, {
        marginTop: `-${bannerElement.offsetHeight}`,
      }).to(this.$refs.previewVideoBoxRef, {
        background: 'rgba(0, 0, 0, 0)'
      }, "<")
    },
    setupVideoIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && !this.videoList[index].playing) {
              this.$refs[this.videoList[index].ref].play().catch(() => {});
              this.videoList[index].playing = true;
            }
          }else {
            const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
            if (index !== -1 && this.videoList[index].playing) {
              this.$refs[this.videoList[index].ref].pause();
              this.$refs[this.videoList[index].ref].currentTime = 0
              this.videoList[index].playing = false;
            }
          }
          // if (entry.intersectionRatio === 0) {
          //   this.videoList.forEach(item => {
          //     if (this.$refs[item.ref] === entry.target) {
          //       this.$refs[item.ref].pause();
          //       this.$refs[item.ref].currentTime = 0;
          //       item.playing = false;
          //     }
          //   });
          // } else if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
          //   this.videoList.forEach(item => {
          //     if (this.$refs[item.ref] === entry.target) {
          //       this.$refs[item.ref].play().catch(e => console.log(item.ref + "视频播放失败:", e));
          //       item.playing = true;
          //     }
          //   });
          // }
          if(this.$refs.improvedContainerRef == entry.target && entry.intersectionRatio >= 0.1 && !this.isImprovedContainerRef){
            this.isImprovedContainerRef = true
            this.initImprovedBannerAnimation()
          }

        });
      }, {
        threshold: [0, 0.1, 0.5, 1.0],
        rootMargin: '0px'
      });

      this.videoList.forEach(item => {
        if (this.$refs[item.ref]) {
          observer.observe(this.$refs[item.ref]);
        }
      });
      observer.observe(this.$refs.improvedContainerRef);

      this.$once('hook:beforeDestroy', () => {
        observer.unobserve(this.$refs.improvedContainerRef);
        this.videoList.forEach(item => {
          if (this.$refs[item.ref]) {
            observer.unobserve(this.$refs[item.ref]);
          }
        });
      });
    },
    onVideoProgress(event) {
      const video = event.target;
      const currentTime = video.currentTime;
      const duration = video.duration;

      const videoIndex = this.videoList.findIndex(item => {
        return this.$refs[item.ref] === video;
      });

      if (videoIndex !== -1) {
        this.videoList[videoIndex].progress = ((currentTime / duration) * 100).toFixed(2);
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let head_height = this.$refs.head.getHeaderHeight()
      if (scrollTop > head_height) {
        this.productc_nav = true
        this.scroll_height = scrollTop
      } else {
        this.productc_nav = false
      }
      this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
    },
    ChangeEmit(){
      this.$refs.is_change.get_index_channel_data();
      this.$refs.is_change.pageParam();
    },
  },
  beforeDestroy() {
    this.removeSliderHoverListener();
    ScrollTrigger.getAll().forEach(t => t.kill());
  }
};
</script>

<style >
h1, h2, h3, h4, h5, h6, p {
  padding: 0;
  margin: 0;
}

.special-main h1, .special-main h2, .special-main h3 {
  font-family: 'OPPOSans-H', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}

.special-main h4, .special-main h5 {
  font-family: 'OPPOSans-B', sans-serif;
  font-weight: normal!important;
  font-size: 20px;
  color: #1B1B1B ;
}
.special-main p {
  font-family: 'OPPOSans-B', sans-serif;
  font-size: 20px;
  color: #7d7d7d ;
  margin: 0;
  padding: 0;
}



.product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 35%,
  #ef5c11 60%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 60px;
  text-align: center;
  font-weight: 500;
  letter-spacing: -4px;
}

.product-special-title .product-special-title-b p {
  font-family: 'segoesc', sans-serif;
  text-align: center;
  color: #f45229;
  margin-top: 20px;
  font-size: 16px;
}

.product-detail-text1 {
  margin-top: 63px;
}

.product-detail-text1 .txt {
  color: #707070;
  font-size: 20px;
  line-height: 1.6;
}

.product-detail-text1 .button {
  margin: 40px auto 0 auto;
}

.product-detail-text2 {
  margin: 92px auto 0 auto;
  width: 990px;
}

.product-detail-text2 .txt {
  margin-top: 10px;
}

.product-detail-text2 .txt:first-child {
  margin-top: 0;
}

.special-main .special-body .banner-container {
  position: relative;
  height: 100vh;
}

.special-main .special-body .banner-container .banner {
  width: 100%;
  height: 100vh;
  background: #fff;
  overflow: hidden;
}

.special-main .special-body .banner-container .banner img {
  width: 100%;
  display: block;
}

.special-main .special-body .banner-container .banner .banner-logo {
  width: 443px;
  margin: 85px auto 0 auto;
}
.special-main .special-body .banner-container .banner .banner-title {
  text-align: center;
  color: #696969;
  margin-top: 36px;
  font-size: 23px;
}
.special-main .special-body .banner-container .banner .banner-product {
  width: 800px;
  margin-top: -230px;
  margin-left: 520px;
}
.special-main .special-body .preview-video-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.special-main .special-body .preview-video-container .preview-video-box {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 3;
}

.special-main .special-body .preview-video-container .preview-video-text {
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 4;
}

.special-main .special-body .preview-video-container .preview-video-text h4 {
  color: #ffffff;
  font-size: 60px;
  padding-top: 20px;
  text-align: center;
  font-family: 'OPPOSans-B', sans-serif;
  font-weight: normal!important;
}

.special-main .special-body .preview-video-container .preview-video-text h4:first-child {
  padding-top: 300px;
}

.special-main .special-body .preview-video-container .preview-video-text .button {
  margin: 70px auto 0 auto;
}

.special-main .special-body .preview-video-container .progress {
  position: absolute;
  right: 40px;
  top: 20px;
  z-index: 5;
}

.special-main .special-body .preview-video-container .background-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100vh;
  object-fit: cover;
  z-index: 1;
}

.special-main .special-body .section-product-desc {
  padding: 100px 0 150px 0;
  background: linear-gradient(#fefefe 0%, #f5f5f7 50%, #f5f5f7 100%);
}

.special-main .special-body .section-product-desc .product-logo {
  margin: 0 auto;
  width: 134px;
}

.special-main .special-body .section-product-desc .product-logo-text {
  margin: 32px auto 0 auto;
  width: 283px;
}

.special-main .special-body .section-product-desc .product-image {
  margin: 45px auto 0 auto;
  width: 100%;
}

.special-main .special-body .section-product-desc .step-list {
  width: 980px;
  margin: 47px auto 0 auto;
}

.special-main .special-body .section-product-desc .step-list .step-item {
  width: 980px;
  height: 319px;
  position: relative;
  overflow: hidden;
  border-radius: 30px;
  margin-top: 22px;
}

.special-main .special-body .section-product-desc .product-detail-text1 .txt {
  font-size: 24px;
}

.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt {
  position: absolute;
  left: 80px;
  top: 75px;
}
.txt-big {}

.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title {
  display: flex;
  position: relative;
  width: 93px;
}
.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title h5,
.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title img {
  display: block;
  width: 93px;
}

.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .step-video-title h5 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  font-weight: 500;
}

.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .txt-big {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ef5c11 30%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 50px;
  font-weight: bold;
  margin-left: 5px;
}
.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .txt-middle {
  font-size: 40px;
}
.special-main .special-body .section-product-desc .step-list .step-item .step-video-txt .txt-small{
  font-size: 20px;
}

.special-main .special-body .section-product-desc .step-list .step-item:first-child {
  margin-top: 0;
}

.special-main .special-body .section-product-desc .step-list .step-item video {
  width: 990px;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
}

.special-main .special-body .section-product-desc .product-video-container {
  position: relative;
  width: 1250px;
  border-radius: 30px;
  overflow: hidden;
  margin: 24px auto 0 auto;
}

.special-main .special-body .section-product-desc .product-video-container .product-video {
  width: 100%;
  display: block;
}

.special-main .special-body .section-product-desc .product-video-container .progress {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 5;
}

.special-main .special-body .section-product-desc img {
  display: block;
  width: 100%;
}

.special-main .special-body .section-product-suit {
  background: #ffffff;
  padding-bottom: 400px;
}

.special-main .special-body .section-product-suit .product-logo {
  width: 234px;
}

.special-main .special-body .section-product-suit .product-logo-text {
  width: 270px;
  margin-top: -30px;
}

.special-main .special-body .section-product-suit .product-special-title {
  margin-top: 80px;
  padding-bottom: 20px;
}

.special-main .special-body .section-product-suit .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 30%,
  #ef5c11 60%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
}

.special-main .special-body .section-product-suit .product-special-title .product-special-title-b p {
  margin-top: 7px;
}

.special-main .special-body .section-product-suit .g-preview-video-container {
}

.special-main .special-body .section-product-suit .product-detail-text1 {
  margin-top: 40px;
}

.special-main .special-body .section-product-suit .product-detail-text1 .txt {
  margin-top: 0;
  font-size: 24px;
}

.special-main .special-body .section-product-suit .product-detail-text1 .txt:first-child {
  //margin-top: 159px;
}

.special-main .special-body .section-product-suit .product-detail-text3 {
  margin-top: 160px;
  width: 800px;
}

.special-main .special-body .section-product-suit .g-mode-video-container {
  width: 100%;
  margin-top: 35px;
}

.special-main .special-body .improved-container {
  width: 100%;
  height: 100vh;
  position: relative;
  z-index: 1;
}

.special-main .special-body .improved-container .improved-banner {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #000000;
}


/*.special-main .special-body .improved-container .improved-banner .blur-after {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  background-image: url("https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260126/ca5242c0b54e423c9163c10e8518efe7.png");
}*/
.special-main .special-body .improved-container .improved-banner .improved-background {
  position: absolute;
  width: calc(100vw - 12.55px);
  height: 100vh;
  z-index: 2;
  left: 0;
  top: 0;
  backdrop-filter: blur(20px) brightness(.6) ;
  opacity: 0;
  pointer-events: none;

}

.special-main .special-body .improved-container .improved-banner .improved-banner-text {
  position: absolute;
  left: 1116px;
  top: 80px;
}

.special-main .special-body .improved-container .improved-banner .improved-banner-text .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 5%,
  #ef5c11 50%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  text-align: left;
  font-size: 66px;

}

.special-main .special-body .improved-container .improved-banner .improved-banner-text .product-special-title .product-special-title-p {
  margin-top: 35px;
}

.special-main .special-body .improved-container .improved-banner .improved-banner-text .product-special-title .product-special-title-p p {
  color: #ffffff;
  letter-spacing: 1px;
  font-size: 26px;
  line-height: 1.6;
}

.special-main .special-body .improved-container .improved-banner img {
  width: 100%;
  display: block;
  object-fit: cover;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: -265px;
}

.special-main .special-body .improved-container .improved-banner  .improved-banner-img {

}

.special-main .special-body .improved-container .improved-content {
  width: 100%;
  height: 100vh;
  position: relative;
  z-index: 2;
}

.special-main .special-body .improved-container .improved-content .improved-content-container{
  display: flex;
  flex-direction: column;
  padding: 153px 0 0 542px;
}

.special-main .special-body .improved-container .improved-content .improved-content-title-info {

}
.special-main .special-body .improved-container .improved-content .improved-content-title-info .product-special-title {
  margin-top: 0;
}

.special-main .special-body .improved-container .improved-content .improved-button {
  margin-top: 42px;
}

.special-main .special-body .improved-container .improved-content .improved-content-title-info .product-special-title .product-special-title-b h5 {
  font-size: 65px;
}

.special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title{
  margin-top: 42px;
}
.special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title .product-special-title-b h5 {
  font-size: 27px;
  font-weight: 500;
  letter-spacing: -1px;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 5%,
  #ff6e0b 22%,
  #ff6e0b 100%);
  -webkit-background-clip: text;
  background-clip: text;
}
.special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title .product-special-title-p{
  margin-top: 7px;
}
.special-main .special-body .improved-container .improved-content .improved-content-detail .product-special-title .product-special-title-p p {
  font-size: 16.5px;
  font-weight: 500;
  letter-spacing: 0px;
}


.special-main .special-body .improved-container .improved-content .product-special-title {
  margin-top: 80px;
}

.special-main .special-body .improved-container .improved-content .product-special-title .product-special-title-b h5 {
  font-size: 40px;
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 3%,
  #f67126 20%,
  #f67126 100%);
  -webkit-background-clip: text;
  background-clip: text;
}

.special-main .special-body .improved-container .improved-content .product-special-title  .product-special-title-p {
  margin-top: 60px;
}
.special-main .special-body .improved-container .improved-content .product-special-title  .product-special-title-p p {
  color: #ffffff;
  font-weight: bold;
  letter-spacing: 2px;
  line-height: 1.8;
}
.special-main .special-body .improved-container .improved-content img {
  display: block;
  width: 100%;
}
.special-main .special-body .improved-container .improved-content .torque-sense {
  margin-top: 212px;
  padding-right: 183px;
}

.special-main .special-body .improved-container .improved-content .torque-sense .torque-sense-logo,
.special-main .special-body .improved-container .improved-content .atr-mode .atr-mode-logo {
  width: 143px;
}

.special-main .special-body .improved-container .improved-content .torque-sense .torque-sense-logo {
  margin: 0 auto;
}
.special-main .special-body .improved-container .improved-content .atr-mode .atr-mode-logo {
  margin-left: 20px;
}

.special-main .special-body .improved-container .improved-content .atr-mode {
  margin-top: 212px;
  padding-left: 183px;
}
.special-main .special-body .improved-container .improved-content .atr-mode .atr-mode-logo {

}


.contra-angle-container {
  background-color: #000000;
  padding-bottom: 190px;
  position: relative;
  z-index: 2;
}

.contra-angle-container .contra-angle-banner {

}

.contra-angle-container .contra-angle-banner img {
  display: block;
  width: 100%;
}

.contra-angle-container .contra-angle-banner .contra-angle-box{
  position: relative;
}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title {
  position: absolute;
  left: 544px;
  top: 210px;
}

.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .bending-head {
  width: 145px;
  margin-bottom: 25px;
}

.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .bending-head img {
  display: block;
  width: 100%;
}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-b {

}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-b h5 {
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ed570d 50%,
  #ed570d 100%);
  -webkit-background-clip: text;
  background-clip: text;
}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-b h5 {
  font-size: 60px;
}

.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-p {
  margin-top: 30px;
}
.contra-angle-container .contra-angle-banner .contra-angle-box .product-special-title .product-special-title-p p{
  color: #b1b1b1;
  font-size: 25px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text {
  padding-left: 544px;
}

.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .product-special-title-b h5 {
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 3%,
  #ef5c11 15%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
}


.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter {
  margin-top: 20px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align:nth-child(2) {
  margin-left: 68px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-b h5 {
  font-size: 30px;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 10%,
  #ef5c11 70%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  letter-spacing: 0px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-p {
  margin-left: 7px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p,
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .contra-angle-parameter .bottom-align .product-special-title-p p {
  font-size: 20px;
  color: #b1b1b1;
}

.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p {
  font-size: 26px;
}

.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc {
  margin-top: 33px;
}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p{

}
.contra-angle-container .contra-angle-banner .contra-angle-banner-text .product-special-title .contra-angle-desc p:first-child {
  margin-top: 0;
}

.contra-angle-container .contra-angle-animation {
  background-color: #000000;
  padding-top: 41px;
}
.contra-angle-container .contra-angle-slider {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
}
.contra-angle-container .contra-angle-slider .el-slider {
  width: 300px;
}
.contra-angle-container .contra-angle-slider i {
  display: block;
  width: 50px;
}

.contra-angle-container .contra-angle-slider .dark {
  margin-right: 19px;
}
.contra-angle-container .contra-angle-slider .light {
  margin-left: 19px;
}
.contra-angle-container .contra-angle-slider i img {
  display: block;
  width: 100%;
}
.contra-angle-container .contra-angle-slider .el-slider__bar,
.contra-angle-container .contra-angle-slider .el-slider__runway {
  height: 12px;
  border-radius:50px;
}
.contra-angle-container .contra-angle-slider .el-slider__bar {
  background-color: #6c5dd3;
}
.contra-angle-container .contra-angle-slider .el-slider__button {
  position: absolute;
  top:50%;
  left: 50%;
  margin-top: -13px;
  margin-left: -13px;
  background-color: #6c5dd3;
  border: 0;
  width: 30px;
  height: 30px;
}
.contra-angle-animation .contra-angle-animation-container {
  width: 834px;
  margin: 30px auto 0 auto;
}
.contra-angle-animation .contra-angle-animation-container img {
  display: block;
  width: 100%;
}


.section-build-file {
  padding-top: 120px;
}
.section-build-file .product-special-title {}
.section-build-file .product-special-title .product-special-title-b {}
.section-build-file .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 40%,
  #ef5c11 50%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 66px;

}
.section-build-file .product-special-title .product-special-title-b p {
  margin-top: 11px;
  font-size: 17px;
}
.section-build-file .build-file-video-container {}
.section-build-file .build-file-video-container .build-file-video {
  display: block;
  //width: 1000px;
  margin:  40px auto 0 auto;
}
.section-build-file .product-detail-text1 {
  margin-top: 53px;
}
.section-build-file .product-detail-text1 .txt {
  font-size: 19.7px;
}
.selection-magnetic {
  background-color: #fefefe;
  padding-top: 100px;
}

.selection-magnetic .magnetic-video {
  width: 1252px!important;
}

.selection-magnetic .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 30%,
  #ef5c11 50%,
  #ef5c11 100%);
  -webkit-background-clip: text;
  background-clip: text;
}


.section-touch-screen {
  padding-top: 205px;
  background: linear-gradient(#fefefe 0%, #f5f5f7 50%, #f5f5f7 100%);
}
.section-touch-screen .touch-screen-list {
  display: flex;
  justify-content: center;
  align-items: center;
}
.section-touch-screen .touch-screen-list .touch-screen-item:nth-child(even){
  margin-left: 53px;
}

.section-touch-screen .touch-screen-list .touch-screen-item .product-special-title {
  padding-bottom: 50px;
  display: flex;
  justify-content: right;
}

.section-touch-screen .touch-screen-list .touch-screen-item:nth-child(even) .product-special-title {
  justify-content: left;
}

.section-touch-screen .touch-screen-list .touch-screen-item:nth-child(even) .product-special-title .product-detail-text1 {
  margin-bottom: 28px;
  margin-top: 0px;
}
.section-touch-screen .touch-screen-list .touch-screen-item:nth-child(even) .product-special-title .product-detail-text1 .txt {
  font-size: .135rem;
}
.section-touch-screen .touch-screen-list .touch-screen-item .product-special-title .product-special-title-b {
  margin-right: 90px;
}
.section-touch-screen .touch-screen-list .touch-screen-item .product-special-title-b h5{
  text-align: left;
}
.section-touch-screen .touch-screen-list .touch-screen-item .product-detail-text1 {
  padding-left: 10px;
}
.section-touch-screen .touch-screen-list .touch-screen-item .image {
  width: 712px;
}
.section-touch-screen .touch-screen-list .touch-screen-item .image img {
  display: block;
  width: 100%;
}

.special-main .section-packaging {
  margin-top: 230px;
}

.special-main .section-packaging .product-special-title .product-special-title-b h5 {
  color: transparent;
  background: linear-gradient(to right,
  #39ed54 0%,
  #39ed54 40%,
  #0db60c 70%,
  #0db60c 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 67px;
}

.special-main .section-packaging .product-detail-text1 {
  margin-top: 40px;
}
.special-main .section-packaging .product-detail-text1 .txt {
  font-size: 19.7px;
}
.special-main .section-packaging .product-detail-text1 .txt:last-child {
  margin-top: 30px;
}
.special-main .section-packaging .image {
  width: 1475px;
  margin: 100px auto 0 auto;
}
.special-main .section-packaging .image img {
  display: block;
  width: 100%;
  border-radius: 30px;
}


.section-touch-screen .keep-exploring {
  width: 1250px;
  margin: 200px auto 0 auto;
  padding-bottom: 166px;
}
.section-touch-screen .keep-exploring .keep-exploring-container {
  background-color: #ffffff;
  padding: 80px 50px 168px 50px;
  margin-top: 42px;
  border-radius: 30px;
}

.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product {
  padding: 80px 110px 120px 110px;
  display: flex;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .image {
  width: 230px;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .image img {
  display: block;
  width: 100%;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .desc {
  margin-left: 163px;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .desc .title {
  font-size: 32px;
  font-weight: 500;
  margin-top: 86px;

}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product .desc .info {
  font-size: 21px;
  color: #666666;
  margin-top: 40px;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter{
  padding: 0 110px;
  display: flex;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter .keep-exploring-product-parameter-item{
  margin-left: 163px;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter .keep-exploring-product-parameter-item:first-child{
  margin-left: 0;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter .keep-exploring-product-parameter-item .param {
  width: 230px;
  font-size: 20px;
  margin-top: 20px;
}
.section-touch-screen .keep-exploring .keep-exploring-container .keep-exploring-product-parameter .keep-exploring-product-parameter-item .param:first-child{
  margin-top: 0;
}
.section-touch-screen .keep-exploring .keep-exploring-container .line {
  display: block;
  border-top: #e7e7e9 1px solid;
  width: 925px;
  margin: 60px 0 0 115px;
}
.section-touch-screen .keep-exploring .product-special-title .product-special-title-b h5 {
  text-align: left;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 1%,
  #ec540a 5%,
  #ec540a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 52px;
}
.section-touch-screen .keep-exploring .mode-list {
  display: flex;
  justify-content: center;

}
.section-touch-screen .keep-exploring .mode-list .mode-item {
  width: 450px;
  //margin-left: 72px;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .mode-item-box {
  //padding-right: 45px;
}
.section-touch-screen .keep-exploring .mode-list .mode-item:first-child {
  margin-left: 0;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .image {
  width: 152px;
  margin: 0 auto;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .image img {
  display: block;
  width: 100%;
}
.section-touch-screen .keep-exploring .mode-list .mode-item {

}
.section-touch-screen .keep-exploring .mode-list .mode-item .title {
  font-size: 20px;
  margin-top: 60px;
  color: #0f0f0f;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .txt {
  font-size: 17px;
  margin-top: 17px;
  color: #2a2a2a;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .txt.fc {
  color: #837871;
}
.section-touch-screen .keep-exploring .mode-list .mode-item .txt:first-child {
  margin-top: 0;
}

.section-touch-screen .keep-exploring .mode-function {}
.section-touch-screen .keep-exploring .mode-function .mode-function-item {}
.section-touch-screen .keep-exploring .mode-function .mode-function-item .title {
  font-weight: 500;
}
.section-touch-screen .keep-exploring .mode-function .mode-function-item .small {
  font-size: 13px;
}

.section-touch-screen .keep-exploring .specifications-container {
  margin-top: 64px;
  margin-left: 120px;
}
.section-touch-screen .keep-exploring .specifications-container .product-special-title {}
.section-touch-screen .keep-exploring .specifications-container .product-special-title .product-special-title-b {}
.section-touch-screen .keep-exploring .specifications-container .product-special-title .product-special-title-b h5 {
  font-size: 28px;
  color: transparent;
  background: linear-gradient(to right,
  #fdb87d 0%,
  #fdb87d 1%,
  #eb5108 5%,
  #eb5108 100%);
  -webkit-background-clip: text;
  background-clip: text;
  letter-spacing: -1px;
}

.section-touch-screen .keep-exploring .specifications-container .specifications-list {}
.section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item {
  margin-top: 30px;
  display: flex;
}
.section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item .title {
  font-size: 18px;
  color: #333333;
  margin-top: 0;
  line-height: 1.6;
}
.section-touch-screen .keep-exploring .specifications-container .specifications-list .specifications-item .txt {
  color: #6f6f74;
  font-size: 18px;
  line-height: 1.6;
  width: 150px;
}

.section-bottom-banner {
}
.section-bottom-banner img {
  display: block;
  width: 100%;
}
</style>
